import React, { useEffect, useState, useContext } from "react";
import { Col, Row, Tooltip, Button, Form, Input, Select } from "antd";
import { EditOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { GenericContext } from "../../context/genericContext";
import AdminDataTable from "../../Layouts/partials/data-table";
import { CompanyContext } from "../../context/CompanyContext";
import { ConfirmationModal } from "../../components/Modals/index";
import { Link } from "react-router-dom";
import {
  CREATE_COMPANY_ROUTE,
  UPDATE_COMPANY_ROUTE,
  COMPANY_DETAIL_ROUTE,
  PERMISSIONS,
  STATUS_FILTER,
} from "../../constants";
import { getFormattedDateTime } from "../../utils";
import FilterDrawer from "../../components/filterDrawer";
import { ScaleLoader } from "react-spinners";
import moment from "moment";
function Company() {
  const { companyList, getCompanyList, deleteCompany } =
    useContext(CompanyContext);
  const { getUserPermission, userPermissions } = useContext(GenericContext);
  const [selectedData, setSelectedData] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const CreateAccess = PERMISSIONS.find(
    (x) => x.route === CREATE_COMPANY_ROUTE
  );
  const UpdateAccess = PERMISSIONS.find(
    (x) => x.route === UPDATE_COMPANY_ROUTE.replace("/:id", "")
  );
  const [filteredData, setFilteredData] = useState({
    is_active: "1",
  });
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [page, setPage] = useState(1);
  const { meta, data } = companyList;
  const paginationConfig = {
    pageSize: meta?.per_page,
    total: meta?.total,
  };

  const [form] = Form.useForm();
  const handleFormFinish = () => {
    const credentials = form.getFieldsValue();
    setFilteredData(credentials);
    setLoading(true);
  };

  useEffect(() => {
    let filterQuery = "";
    if (filteredData) {
      Object.keys(filteredData).forEach(function (key) {
        if (filteredData[key]) {
          filterQuery += `&${key}=${filteredData[key]}`;
        }
      });
    }
    getCompanyList(page, true, filterQuery, () => {
      setLoading(false);
      setFilterOpen(false);
    });
    getUserPermission();
  }, [page, filteredData]);

  const handleResetForm = () => {
    form.resetFields();
    setFilteredData(null);
    form.setFieldsValue({
      code: undefined,
      name: undefined,
      is_active: undefined,
    });
    setFilterOpen(false);
  };
  const drawerSec = () => (
    <Form
      form={form}
      className="form"
      initialValues={filteredData}
      onFinish={handleFormFinish}
    >
      <label className="form-lbl">Name:</label>
      <Form.Item name={"name"}>
        <Input
          name="name"
          placeholder="Filter by company name"
          className="form-input"
        />
      </Form.Item>
      <label className="form-lbl">Code:</label>
      <Form.Item name={"code"}>
        <Input
          name="code"
          placeholder="Filter by company code"
          className="form-input"
        />
      </Form.Item>
      <label className="form-lbl">Status:</label>
      <Form.Item name={"is_active"}>
        <Select
          placeholder="Filter by company status"
          name="is_active"
          className="form-select"
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {STATUS_FILTER.map((data, index) => (
            <Select.Option value={data.id} key={index}>
              {data.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item>
        <Button
          htmlType="submit"
          disabled={isLoading}
          className="form-btn"
          style={{ minWidth: "100%" }}
        >
          {isLoading ? (
            <ScaleLoader
              color={"#FFF"}
              loading={isLoading}
              height={14}
              width={2}
            />
          ) : (
            "Apply Filters"
          )}
        </Button>
        <span className="form-rm-btn" onClick={handleResetForm}>
          Reset Filters
        </span>
      </Form.Item>
    </Form>
  );

  const columns = [
    {
      title: "No",
      dataIndex: "No",
      key: "1",
      render: (data, value, i) => (
        <b>{(page == 1 ? 0 : (page - 1) * 10) + (i + 1)}</b>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "2",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (data, value) => {
        return <span>{data}</span>;
      },
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "3",
      sorter: (a, b) => a.code.localeCompare(b.code),
      render: (data, value) => {
        return <span>{data}</span>;
      },
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "4",
      sorter: (a, b) =>
        a.locations[0]?.name.localeCompare(b.locations[0]?.name),
      render: (data, value) => {
        return <span>{data.name}</span>;
      },
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "5",
      sorter: (a, b) => a.is_active - b.is_active,
      render: (data, value) => {
        return <span>{data === 1 ? "Active" : "Inactive"}</span>;
      },
    },
    {
      title: "Created By",
      dataIndex: "creator",
      key: "6",
      sorter: (a, b) => a.creator?.email.localeCompare(a.creator?.email),
      render: (data, value) => {
        return <span>{data.email}</span>;
      },
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "7",
      sorter: (a, b) =>
        moment(a.created_at).unix() - moment(b.created_at).unix(),
      render: (data, value) => {
        return <span>{getFormattedDateTime(data)}</span>;
      },
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "8",
      sorter: (a, b) =>
        moment(a.updated_at).unix() - moment(b.updated_at).unix(),
      render: (data, value) => {
        return <span>{getFormattedDateTime(data)}</span>;
      },
    },
    {
      title: "Action",
      key: "9",
      render: (data, record) => {
        return (
          <div className="actions">
            <Link
              to={COMPANY_DETAIL_ROUTE.replace(":dataid", data.id)}
              className="update"
            >
              <Tooltip title="Company Detail">
                <EyeOutlined />
              </Tooltip>
            </Link>

            {userPermissions.includes(UpdateAccess.access) && (
              <Link
                to={UPDATE_COMPANY_ROUTE.replace(":id", data.id)}
                className="update"
              >
                <Tooltip title="Update Company">
                  <EditOutlined />
                </Tooltip>
              </Link>
            )}
            {/* <span style={{ opacity: data.is_default ? 0.3 : 1 }}>
              {data.is_default ? (
                <DeleteOutlined style={{ cursor: "auto" }} />
              ) : (
                <Tooltip title="Delete Company">
                  <DeleteOutlined onClick={() => handleConfirmModal(record)} />
                </Tooltip>
              )}
            </span> */}
          </div>
        );
      },
    },
  ];

  //HANDLERS

  const handleConfirmModal = (role) => {
    setSelectedData(role);
    setShowConfirmationModal(true);
  };
  const handleConfirmationModalClose = () => {
    setShowConfirmationModal(false);
  };

  const handleDeleteRole = (id) => {
    deleteCompany(id);
  };

  const handlePageChange = (page, pageSize) => {
    setPage(page);
  };

  const filterHandler = () => {
    setFilterOpen(!isFilterOpen);
  };

  return (
    <>
      <div className="layout-content">
        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
            {userPermissions.includes(CreateAccess.access) && (
              <div className="add-btn">
                <Link to={CREATE_COMPANY_ROUTE}>Create Company</Link>
              </div>
            )}
            <AdminDataTable
              title="Companies"
              filterHandler={filterHandler}
              data={data}
              columns={columns}
              pagination={{ ...paginationConfig, onChange: handlePageChange }}
            />
          </Col>
        </Row>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          handleClose={handleConfirmationModalClose}
          title={"Delete Company?"}
          description={"Are you sure you want to delete this company?"}
          deleteHandler={handleDeleteRole}
          selectedData={selectedData}
        />
      )}
      <FilterDrawer
        visible={isFilterOpen}
        toggle={filterHandler}
        content={drawerSec()}
      />
    </>
  );
}

export default Company;
